var admin_emails = [
    "truceengineer@gmail.com",
    "jpet88@gmail.com",
    "15kumarviv@gmail.com",
    "arnob.sengupta100@gmail.com",
    "joey@truce.io"
];

export default admin_emails;
